import { render, staticRenderFns } from "./ViewExercise.vue?vue&type=template&id=60547417&scoped=true&"
import script from "./ViewExercise.vue?vue&type=script&lang=js&"
export * from "./ViewExercise.vue?vue&type=script&lang=js&"
import style0 from "./ViewExercise.vue?vue&type=style&index=0&id=60547417&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60547417",
  null
  
)

export default component.exports